"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.ZERO_ETH_QUANTITY = "0";
var SwapIdPrefix;
(function (SwapIdPrefix) {
    SwapIdPrefix["Ether"] = "ether";
    SwapIdPrefix["Erc20"] = "erc20";
})(SwapIdPrefix = exports.SwapIdPrefix || (exports.SwapIdPrefix = {}));
class SerializationCommon {
    static checkEtherAmount(amounts) {
        if (amounts.length !== 1) {
            throw new Error("Cannot serialize a swap offer with more than one amount");
        }
        const { tokenTicker } = amounts[0];
        if (tokenTicker !== constants_1.constants.primaryTokenTicker) {
            throw new Error("Invalid amount: Ether atomic swap must specify amount in ETH");
        }
    }
    static checkErc20Amount(amounts, erc20Tokens) {
        if (amounts.length !== 1) {
            throw new Error("Cannot serialize a swap offer with more than one amount");
        }
        const { tokenTicker } = amounts[0];
        if (!erc20Tokens.get(tokenTicker)) {
            throw new Error("Invalid amount: unknown ERC20 token");
        }
    }
}
exports.SerializationCommon = SerializationCommon;
//# sourceMappingURL=serializationcommon.js.map